import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Typography,
  FormControl,
  Select,
  MenuItem,
} from '@mui/material';

export const FREQUENCIES = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
};

export default function FrequencySelector({ frequency, onChange }) {
  const { t } = useTranslation('common');

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Typography>{t('common:rrule.frequency.repeat')}</Typography>
      <FormControl size="small" sx={{ minWidth: 120 }}>
        <Select
          value={frequency}
          onChange={(e) => onChange(e.target.value)}
        >
          <MenuItem value={FREQUENCIES.DAILY}>
            {t('common:rrule.frequency.daily')}
          </MenuItem>
          <MenuItem value={FREQUENCIES.WEEKLY}>
            {t('common:rrule.frequency.weekly')}
          </MenuItem>
          <MenuItem value={FREQUENCIES.MONTHLY}>
            {t('common:rrule.frequency.monthly')}
          </MenuItem>
          <MenuItem value={FREQUENCIES.YEARLY}>
            {t('common:rrule.frequency.yearly')}
          </MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}
